import { createApi } from "@reduxjs/toolkit/query/react";
import { adminBaseQueryWrapper } from "@/utils/rtkHelper";


export const AllCompanyApi = createApi({
    reducerPath: "Api",
    baseQuery: adminBaseQueryWrapper,
    tagTypes: ["all-company"],
    keepUnusedDataFor: 0,
    endpoints: (builder) => ({
        getRealTimeProfitChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/all-company/real-time-profit/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["all-company"],
        }),
        getUpcomingProfitChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/all-company/upcoming-profit/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["all-company"],
        }),
        getTotalOrdersChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/all-company/total-order-chart/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["all-company"],
        }),
        getDropdownOptions: builder.query({
            query: () => `/all-company/sku/sku-dropdown`,
            providesTags: ["all-company"],
        }),
        getNetProfitChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/all-company/net-profit/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["all-company"],
        }),
        getReturnStatusChartChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/all-company/return-status-chart/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["all-company"],
        }),
        getChargeableAmtChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/all-company/chargeable-amounts/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["all-company"],
        }),
        getTop10SkuProfitChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/all-company/top-10-sku-profit-chart/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["all-company"],
        }),
        getTop10SkuLossChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/all-company/top-10-sku-loss-chart/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["all-company"],
        }),
        getTop10SalesSkuChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/all-company/top-10-sales-sku/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["all-company"],
        }),
        getTop10CityWiseSalesOrderChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/all-company/top-10-sales-order-city-wise/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["all-company"],
        }),
        getTop10StateWiseSalesOrderChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/all-company/top-10-sales-order-state-wise/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["all-company"],
        }),
        getTop10SkuOfCustomerReturnChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/all-company/top-10-sku-of-customer-return/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["all-company"],
        }),
        getTop10CustomerReturnChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/all-company/top-10-customer-return/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["all-company"],
        }),
        getTop10StateWiseCustomerReturnChart: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/all-company/top-10-customer-returns-state/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["all-company"],
        }),
        getDashboardCounts: builder.query({
            query: ({ startDate, endDate, skuId }) =>
                `/all-company/dashboard-count/?start_date=${startDate}&end_date=${endDate}&sku_id=${skuId}`,
            providesTags: ["all-company"],
        }),
      

    }),

})

export const {
    useGetRealTimeProfitChartQuery,
    useGetUpcomingProfitChartQuery,
    useGetTotalOrdersChartQuery,
    useGetDropdownOptionsQuery,
    useGetNetProfitChartQuery,
    useGetReturnStatusChartChartQuery,
    useGetChargeableAmtChartQuery,
    useGetTop10SkuProfitChartQuery,
    useGetTop10SkuLossChartQuery,
    useGetTop10SalesSkuChartQuery,
    useGetTop10SkuOfCustomerReturnChartQuery,
    useGetTop10CityWiseSalesOrderChartQuery,
    useGetTop10StateWiseSalesOrderChartQuery,
    useGetTop10CustomerReturnChartQuery,
    useGetTop10StateWiseCustomerReturnChartQuery,
    useGetDashboardCountsQuery,
} = AllCompanyApi;
